/**
 * IndexDB封装
 */

interface StoreParams {
    name: string;
    keyPath: string;
}

interface ConstructorParams {
    dbName: string;
    dbVersion: number;
    storeNames: StoreParams[];
}

// eslint-disable-next-line import/prefer-default-export
export default class SSIndexDB {
    constructor({ dbName, dbVersion, storeNames }: ConstructorParams) {
        this.db = null;
        this.dbName = dbName;
        this.dbVersion = dbVersion;
        this.storeNames = storeNames;
        // this.open().finally();
    }

    db: any = null;

    dbName: string;

    dbVersion: number;

    storeNames: StoreParams[];

    open() {
        return new Promise((resolve, reject) => {
            const indexedDB = window.indexedDB || (window as any).webkitIndexedDB || (window as any).mozIndexedDB || (window as any).msIndexedDB || '';
            if (!indexedDB) {
                reject(new Error('Your browser does not support IndexedDB'));
                return;
            }

            const request = indexedDB.open(this.dbName, this.dbVersion);

            request.onerror = (event) => {
                console.log('open onerror', event);
                reject(request.error);
            };

            request.onsuccess = (event) => {
                console.log('open onsuccess', event);
                this.db = request.result;
                resolve(request.result);
            };

            request.onupgradeneeded = (event) => {
                const db = (event.target as any).result;
                this.storeNames.forEach((item: StoreParams) => {
                    if (!db.objectStoreNames.contains(item.name)) {
                        db.createObjectStore(item.name, { keyPath: item.keyPath });
                    }
                });
            };
        });
    }

    close() {
        if (this.db) {
            this.db.close();
            this.db = null;
        }
    }

    getAllItems(storeName: string) {
        if (!this.db) {
            return Promise.reject(new Error('Database is not open'));
        }
        return new Promise((resolve, reject) => {
            const transaction = this.db.transaction([storeName]);
            const objectStore = transaction.objectStore(storeName);
            const request = objectStore.getAll();

            request.onerror = (event: Event) => {
                console.error('getAllItems error', request.error, event);
                reject(request.error);
            };

            request.onsuccess = (event: Event) => {
                // console.log('getAllItems success', request.result, event);
                resolve(request.result);
            };
        });
    }

    getItemById(storeName: string, id: string) {
        if (!this.db) {
            return Promise.reject(new Error('Database is not open'));
        }
        return new Promise((resolve, reject) => {
            const transaction = this.db.transaction([storeName]);
            const objectStore = transaction.objectStore(storeName);
            const request = objectStore.get(id);

            request.onerror = (event: Event) => {
                console.error('getItemById error', request.error, event);
                reject(request.error);
            };

            request.onsuccess = (event: Event) => {
                console.log('getItemById success', request.result, event);
                if (request.result) {
                    resolve(request.result);
                } else {
                    resolve(null);
                }
            };
        });
    }

    addItem(storeName: string, data: any) {
        if (!this.db) {
            return Promise.reject(new Error('Database is not open'));
        }
        return new Promise((resolve, reject) => {
            const transaction = this.db.transaction([storeName], 'readwrite');
            const objectStore = transaction.objectStore(storeName);
            const request = objectStore.add(data);

            request.onerror = () => {
                console.error('addItem error', request.error);
                reject(request.error);
            };

            request.onsuccess = () => {
                console.log('addItem success', request.result);
                resolve(request.result);
            };
        });
    }

    updateItem(storeName: string, data: any) {
        if (!this.db) {
            return Promise.reject(new Error('Database is not open'));
        }
        return new Promise((resolve, reject) => {
            const transaction = this.db.transaction([storeName], 'readwrite');
            const objectStore = transaction.objectStore(storeName);
            const request = objectStore.put(data);

            request.onerror = () => {
                console.error('updateItem error', request.error);
                reject(request.error);
            };

            request.onsuccess = () => {
                console.log('updateItem success', request.result);
                resolve(request.result);
            };
        });
    }

    deleteItem(storeName: string, id: string) {
        if (!this.db) {
            return Promise.reject(new Error('Database is not open'));
        }
        return new Promise((resolve, reject) => {
            const transaction = this.db.transaction([storeName], 'readwrite');
            const objectStore = transaction.objectStore(storeName);
            const request = objectStore.delete(id);

            request.onerror = () => {
                console.error('deleteItem error', request.error);
                reject(request.error);
            };

            request.onsuccess = () => {
                console.log('deleteItem success', request.result);
                resolve(request.result);
            };
        });
    }
}
